import type { Server } from '@festina-life/core'

import { useAuthenticationContext } from '../context/authenticationContext'
import { useGetUserRoles } from './useGetUserRoles'

type Props = {
  component: Server
  rolesToCheck: readonly string[]
}

export const useIsUserAllowedToAccessRoles = () => {
  const { data: userRoles } = useGetUserRoles()
  const { shouldValidateAuthenticationHooks } = useAuthenticationContext()

  return ({ component, rolesToCheck: roles }: Props) =>
    !shouldValidateAuthenticationHooks ||
    roles.every((role) => userRoles?.[component]?.has(role))
}
